// Generated by CoffeeScript 2.7.0
var UpdateUsersModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import ResponseImportModelModal from 'trunks/vue/admin/compositions/response_import/response_import_model.js';

import ResponseImportModalMixin from 'trunks/vue/admin/compositions/response_import/response_import_modal_mixin.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default UpdateUsersModal = Vue.extend({
  mixins: [ResponseImportModalMixin],
  components: {
    'modal': Modal,
    'import-model-modal': ResponseImportModelModal
  },
  data: function() {
    return {
      createNewUser: false,
      overwriteTags: false,
      allowBlank: false
    };
  },
  template: `<modal title="批量更新用户"
       extendClass="responses-import-modal update-users-modal"
       ref="modal">
  <import-model-modal :uploadRequest='uploadRequest'
                      :requestError='requestError'
                      :requestSuccess='requestSuccess'
                      :file='file'
                      @closeUploadMask='closeUploadMaskFunc'
                      @removeFile='removeFileFunc'>

    <template slot="importRecords">
      <a href="/admin/import_records"
         class="btn-link gray-text ml-1 mr-1">导入记录-批量更新用户</a>
    </template>

    <template slot="fileUpload">
      <input type="file"
             accept=".xlsx"
             hidden='true'
             @change='filesChangedFunc'
             ref="uploadInput"/>
    </template>
    
    <template slot="tips">
      <div class="option-container">
        <div class="options">
          <label class="option-item">
            <input hidden="true" v-model="createNewUser" type="checkbox">
            <i class="slp-square-o"></i>
            <span class="option-label">是否创建新用户</span>
          </label>
          <label class="option-item">
            <input hidden="true" v-model="overwriteTags" type="checkbox">
            <i class="slp-square-o"></i>
            <span class="option-label">是否覆盖标签</span>
          </label>
          <label class="option-item">
            <input hidden="true" v-model="allowBlank" type="checkbox">
            <i class="slp-square-o"></i>
            <span class="option-label">是否使用表格里空格</span>
          </label>
        </div>
      </div>
    </template>
    
    <template slot="downloadTemplate">
      <a href="/admin/import_records/bulk_update_users_template.xlsx"
         class="gray-link" target="_blank"
         download="批量更新用户.xlsx">点击下载更新模板</a>
    </template>
  </import-model-modal>
  <div class="modal-footer" slot='footer'>
    <button :disabled="requestSuccess"
            class="outlined btn-default"
            @click='cancel'>取消</button>
    <button :disabled="buttonDisabled"
            @click='ensure("ImportRecord::BulkUpdateUsers")'>确定</button>
  </div>
</modal>`,
  methods: {
    ensure: function(type) {
      if (this.requestSuccess) {
        return location.reload();
      } else {
        return this.importFile(type);
      }
    },
    getData: function(id, type) {
      var data;
      return data = {
        type: type,
        attachment_id: id,
        create_new_user: this.createNewUser ? 1 : 0,
        overwrite_tags: this.overwriteTags ? 1 : 0,
        allow_blank: this.allowBlank ? 1 : 0
      };
    },
    doRequest: function(id, type) {
      return Skylark.Libs.Ajax.post("/admin/import_records", {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.getData(id, type),
        success: () => {
          this.requestSuccess = true;
          return this.requestError = false;
        },
        error: function(xhr, status, error) {
          var text;
          text = error.error ? error.error : "导入失败";
          return Skylark.Bridge.newAlertify(text, {
            type: 'error'
          });
        }
      });
    }
  }
});
